import {SimpleCommand} from "./../../../commanding/SimpleCommand";
import {IdentityManagementConstants} from "../../constants/IdentityManagementConstants";
import {BasicDialogHandler} from "../../model/components/BasicDialogHandler";
import {CommonDialogNames} from "../../view/CommonDialogNames";
import {BasicMissingIDCheckDialogProperties} from "../../view/dialogs/BasicMissingIDCheckDialogProperties";
import {BasicStandardOkDialogProperties} from "../../view/dialogs/BasicStandardOkDialogProperties";
import {Localize} from "@goodgamestudios/localization";
import {debug} from "../../../logging/debug";
import {warn} from "../../../logging/warn";

export class BasicHandleIdentityManagementErrorCommand extends SimpleCommand {
    public static NAME: string = "BasicHandleIdentityManagementErrorCommand";

    constructor(singleExecution: boolean = false) {
        super(singleExecution);
    }

    public execute(commandVars: any = null): void {
        let errorCode: number = Number(commandVars);

        debug("execute() -> " + errorCode, commandVars);

        let errorTextId: string;

        switch (errorCode) {


            case IdentityManagementConstants.ERROR_CLIENT_LOGIN_AGE_CHECK_FAILED:
                // Time is between 0:00h - 6:00h and user is too young
                errorTextId = IdentityManagementConstants.TEXT_ID_ERROR_LOGIN_AGE_CHECK_FAILED;
                break;

            case IdentityManagementConstants.ERROR_SERVER_MISSING_KOREA_USER_DATA:
                errorTextId = IdentityManagementConstants.TEXT_ID_SERVER_MISSING_KOREA_ID_CHECK_DATA;
                break;
            case IdentityManagementConstants.ERROR_SERVER_NO_KOREA_USER_DATA_AVAILABLE:
                errorTextId = IdentityManagementConstants.TEXT_ID_ERROR_CLIENT_REGISTER_MISSING_KOREA_ID_CHECK;
                let errorIdCheckMessage: string = Localize.text(errorTextId);
                BasicDialogHandler.getInstance().registerDialogs(CommonDialogNames.KoreaMissingIdCheckDialog_NAME, new BasicMissingIDCheckDialogProperties(Localize.text("generic_alert_watchout"), errorIdCheckMessage));
                return;

            default:
                warn("execute() -> Invalid errorCode: " + errorCode, commandVars);
                //Default error to prevent client crush.
                errorTextId = IdentityManagementConstants.TEXT_ID_SERVER_MISSING_KOREA_ID_CHECK_DATA;
                break;
        }

        let errorMessage: string = Localize.text(errorTextId);

        // Display error code in debug client
        // TODO: @HTML5 - need a proper solution for conditional compiling
        /*if (process.env.DEBUG) {
         errorMessage += ", " + errorCode;
         }*/

        BasicDialogHandler.getInstance().registerDialogs(CommonDialogNames.StandardOkDialog_NAME, new BasicStandardOkDialogProperties(Localize.text("generic_alert_watchout"), errorMessage));
    }
}
